/** The company contacts the landing footer shows. */
export const LANDING_CONTACTS = {
  phone: '(773) 771-1014',
  phoneE164: '+17737711014',
  email: 'office@fr8bot.ai',
} as const;
